'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('sources', {
      url: '/sources',
      template: '<sources></sources>'
    });
}



// WEBPACK FOOTER //
// ./client/app/sources/sources.routes.js